export const SPACING = {
  FINE: '0.25rem',
  TINY: '0.5rem',
  SMALL: '1rem',
  MEDIUM: '1.5rem',
  LARGE: '2rem',
  LARGER: '3rem'
}
